export default {
    UPLOAD:'Upload docs now',
    UPLOAD_LATER:'Upload it later',
}